<div class="modal-container">
  <div mat-dialog-title class="modal-header">
    <div class="modal-header-icon">
      <mat-icon class="material-symbols-outlined">summarize</mat-icon>
    </div>
    <div class="modal-header-titles">
      <h2 class="modal-title">Relatório Consolidado por CFOP</h2>
    </div>
    <div class="modal-header-close-btn-container">
      <button mat-icon-button type="button" class="modal-close-btn"
        aria-label="Fechar relatório por CFOP" (click)="fechar()">
        <mat-icon class="material-symbols-outlined">close</mat-icon>
      </button>
    </div>
  </div>

  <mat-dialog-content class="modal-content">
  <div class="d-flex flex-column gap-3 mb-4">
    <div class="compact-filters">
      <div class="filter-group">
        <span class="label">Período:</span>
        <span class="value">{{ filtros?.dataDe | date:'dd/MM/yyyy' }} até {{ filtros?.dataAte | date:'dd/MM/yyyy'
          }}</span>
      </div>

      <div class="filter-group">
        <span class="label">Status:</span>
        <span class="value">{{ getStatusDescricao(filtros?.isCacnelada) }}</span>
      </div>

      <div class="filter-group">
        <span class="label">Tipos Nota:</span>
        @if(display?.tiposNota && display?.tiposNota?.length > 0) {
        <span class="value">
          @for(tipo of display?.tiposNota; track tipo.idModeloDocumento; let last = $last) {
          {{ tipo.nome }}{{ !last ? ', ' : '' }}
          }
        </span>
        } @else {
        <span class="value">Todos</span>
        }
      </div>
    </div>

    <div class="company-row">
      <span class="label">Empresas ({{display?.empresas?.length || 0}}):</span>
      <div class="chip-wrapper">
        @for(empresa of empresasVisiveis; track empresa.idEmpresa) {
        <span class="simple-chip" [matTooltip]="empresa.cnpj">
          {{ empresa.nomeEmpresa | slice:0:20 }}{{ empresa.nomeEmpresa.length > 20 ? '...' : '' }}
        </span>
        }

        @if(totalEmpresasOcultas > 0) {
        <span class="more-chip" [matTooltip]="tooltipEmpresasOcultas" matTooltipClass="custom-tooltip">
          + {{ totalEmpresasOcultas }} outras
        </span>
        }
      </div>
    </div>
    <app-alert-card type="info" [icon]="'info'" [closable]="true">
      <span>
        <strong>Nota Importante:</strong> Os valores apresentados são o somatório das tags <strong>vProd</strong> (NF-e e
        NFC-e).
      </span>
    </app-alert-card>
  </div>

    @if (_isLoading) {
    <div class="table-responsive">
    <table class="w-100">
      @for (item of [1,2,3]; track item) {
      <tr>
        <td>
          <app-loading-box [height]="'23'" [width]="'110'" [marginTop]="'30'"></app-loading-box>
        </td>
        <td>
          <app-loading-box [height]="'23'" [width]="'220'" [marginTop]="'30'" [marginLeft]="'50'"></app-loading-box>
        </td>
        <td>
          <app-loading-box [height]="'23'" [width]="'320'" [marginTop]="'30'" [marginLeft]="'50'"></app-loading-box>
        </td>
        <td>
          <app-loading-box [height]="'23'" [width]="'40'" [marginTop]="'30'" [marginLeft]="'100'"></app-loading-box>
        </td>
        <td>
          <app-loading-box [height]="'23'" [width]="'40'" [marginTop]="'30'" [marginLeft]="'20'"></app-loading-box>
        </td>
      </tr>
      }
    </table>
    </div>
    }
    @else if (!relatorio || relatorio.length === 0) {
    <div class="empty-state">
      <p>Nenhum dado encontrado para os filtros selecionados.</p>
    </div>
    }
    @else {
    @for (empresa of relatorio; track empresa.cnpj) {
    <div class="empresa-card">
      <div class="empresa-header">
        <div class="empresa-info">
          <strong>CNPJ: {{ empresa.cnpj | cpfCnpj }}</strong>
          <p class="company-name-detail">({{ getNomeEmpresa(empresa.cnpj) }})</p>
        </div>
        <div class="empresa-totais">
          <span class="total-item">
            <span class="lbl">Autorizado:</span>
            <span class="val positivo">{{ empresa.total | currency:'BRL' }}</span>
          </span>
          <span class="separator">|</span>
          <span class="total-item">
            <span class="lbl">Cancelado:</span>
            <span class="val negativo">{{ empresa.totalCancelado | currency:'BRL' }}</span>
          </span>
        </div>
      </div>

      <div class="table-responsive">
      <table mat-table [dataSource]="empresa.listaDetalheCfop" class="compact-table w-100">
        <ng-container matColumnDef="cfop">
          <th mat-header-cell *matHeaderCellDef> CFOP </th>
          <td mat-cell *matCellDef="let element"> {{element.cfop | mask: '0.000' : { patterns: cfopMaskPatterns } }} </td>
        </ng-container>

        <ng-container matColumnDef="valorContabil">
          <th mat-header-cell *matHeaderCellDef class="text-end"> Vlr. Contábil </th>
          <td mat-cell *matCellDef="let element" class="text-end"> {{element.valorTotalSomado | currency:'BRL'}} </td>
        </ng-container>

        <ng-container matColumnDef="valorCancelado">
          <th mat-header-cell *matHeaderCellDef class="text-end"> Vlr. Cancelado </th>
          <td mat-cell *matCellDef="let element" class="text-end"> {{element.valorTotalCancelado |
            currency:'BRL'}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      </div>
    </div>
    }
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="modal-footer">
    <button mat-flat-button type="button" (click)="imprimir()" [disabled]="_isLoading" class="btn-primary">
      <mat-icon>print</mat-icon> Imprimir
    </button>
  </mat-dialog-actions>
</div>
